import { useApi } from '@pidz/api';

const api = useApi();

export const authService = {
  checkSession: (): Promise<CheckSessionResult> => api.rest({
    method: 'get',
    url: '/auth/check-session',
    isMicro: true
  }),

  refreshTokens: (): Promise<RefreshTokensResult> => api.rest({
    method: 'post',
    url: '/auth/refresh-tokens',
    isMicro: true
  }),

  logout: (): Promise<LogoutResponse> => api.rest({
    method: 'post',
    url: '/auth/logout',
    isMicro: true
  }),
}
